import yup from 'schemas/validation/feature'
import outputMapSchema from './outputMapSchema'

const functionSchema = yup.object({
  id: yup.string(),
  description: yup.string().required().unique(),
  uri: yup.string(),
  outputMap: outputMapSchema,
})

export default functionSchema
